import React from 'react'
import { useTheme } from '@mui/material'
const CustomInfoIcon = ({ width = 20, height = 20 }) => {
  const theme = useTheme()
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.8"
        d="M10.3333 18.1667C14.6596 18.1667 18.1667 14.6596 18.1667 10.3333C18.1667 6.0071 14.6596 2.5 10.3333 2.5C6.0071 2.5 2.5 6.0071 2.5 10.3333C2.5 14.6596 6.0071 18.1667 10.3333 18.1667Z"
        fill={theme.palette.tertiary.t01.color}
      />
      <path
        d="M9.52686 9.20228C9.52686 9.06964 9.57955 8.94243 9.67334 8.84863C9.76713 8.75484 9.89434 8.70215 10.027 8.70215C10.1596 8.70215 10.2868 8.75484 10.3806 8.84863C10.4744 8.94243 10.5271 9.06964 10.5271 9.20228V14.2036C10.5271 14.3362 10.4744 14.4635 10.3806 14.5573C10.2868 14.651 10.1596 14.7037 10.027 14.7037C9.89434 14.7037 9.76713 14.651 9.67334 14.5573C9.57955 14.4635 9.52686 14.3362 9.52686 14.2036V9.20228Z"
        fill="#FFFEFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.02539 10.2896C3.02539 11.2206 3.20876 12.1424 3.56504 13.0026C3.92131 13.8627 4.44351 14.6442 5.10182 15.3025C5.76013 15.9608 6.54166 16.483 7.40178 16.8393C8.26191 17.1956 9.18378 17.379 10.1148 17.379C11.0458 17.379 11.9676 17.1956 12.8278 16.8393C13.6879 16.483 14.4694 15.9608 15.1277 15.3025C15.786 14.6442 16.3082 13.8627 16.6645 13.0026C17.0208 12.1424 17.2042 11.2206 17.2042 10.2896C17.2042 8.40936 16.4572 6.60614 15.1277 5.27663C13.7982 3.94711 11.995 3.2002 10.1148 3.2002C8.23455 3.2002 6.43134 3.94711 5.10182 5.27663C3.77231 6.60614 3.02539 8.40936 3.02539 10.2896ZM16.1914 10.2896C16.1914 11.9012 15.5512 13.4468 14.4116 14.5864C13.272 15.726 11.7264 16.3662 10.1148 16.3662C8.50315 16.3662 6.95754 15.726 5.81796 14.5864C4.67837 13.4468 4.03816 11.9012 4.03816 10.2896C4.03816 8.67796 4.67837 7.13235 5.81796 5.99276C6.95754 4.85318 8.50315 4.21296 10.1148 4.21296C11.7264 4.21296 13.272 4.85318 14.4116 5.99276C15.5512 7.13235 16.1914 8.67796 16.1914 10.2896Z"
        fill="#FFFEFE"
      />
      <path
        d="M10.0271 7.70157C10.4414 7.70157 10.7773 7.36569 10.7773 6.95137C10.7773 6.53705 10.4414 6.20117 10.0271 6.20117C9.61273 6.20117 9.27686 6.53705 9.27686 6.95137C9.27686 7.36569 9.61273 7.70157 10.0271 7.70157Z"
        fill="#FFFEFE"
      />
    </svg>
  )
}

export default CustomInfoIcon
